<template>
<div class="manager_dashboard">
   <user-menu />
  <div class="wrapper">
    <masteradmin-sidebar-menu />
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            >
            {{ success_message }}
          </b-alert>
            <div class="col-lg-10 float-left override-padding">
              <h3 class="d-inline heading">Add CSR</h3>
            </div>
            <div class="col-lg-2 float-left override-padding" v-if="list_show == true">
              <button
                      v-on:click="addReseachers()"
                      class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      ><i class="cursor-pointer fa fa-plus" style="font-size: 15px; mpadding-left: 5px; vertical-align: middle;"></i> Add CSR</button>
            </div>
            <div class="col-lg-2 float-left override-padding" v-else>
              <button
                      v-on:click="backLists()"
                      class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      >Back to List</button>
            </div>
            <div style="clear: both"></div>
          </div>
        <div class="heading-seperator"></div>




        <div class="list-users" v-if="list_show == true" style="margin-top: 30px;">
          <table-component v-bind:data="fetchUserData" :show-caption="false" :show-filter="false" :cache-key="1" cache-lifetime="0" ref="table1"  :filter-no-results=no_result()>
              <table-column show="first_name" label="First Name">
              </table-column>
              <table-column show="last_name" label="Last Name">
              </table-column>
              <table-column show="email" :sortable="true" label="Email">
              </table-column>
              <table-column show="phone_number" :sortable="true" label="Phone Number">
              </table-column>
              <table-column :sortable="false" label="Status">
              <template slot-scope="row">
              <span v-if="row.enabled">Active</span>
              <span v-else>Inactive</span>
              </template>
              </table-column>
          </table-component>
        </div>

        <div class="content-main-wrapper signin-form add_account_form center" v-if="add_user == true">
            <researcherform :first_name="first_name" :last_name="last_name" :phone_number="phone_number" :email_addr="email_addr" :password="password" :pw_confirm="pw_confirm" :submit="submit" :action="action" :roles="roles"></researcherform>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import researcherform from './researcherform.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import TableComponent1 from 'vue-table-component';
import axios from 'axios';

TableComponent1.settings({
    tableClass: 'table-responsive table table-hover w-100',
    theadClass: '',
    tbodyClass: '',
    filterPlaceholder: 'Filter table…',
});

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
	    password: '',
      pw_confirm: '',
      submit: 'Create CSR',
	    action: 'insert',
      roles: 'ROLE_CSR',
      len: 0,
      list_show: true,
      add_user: false,
      success_message: '',
      dismissCountDown: 0,
    }
  },
  components: {
    researcherform,
    UserMenu,
    GoBack,
    MasteradminSidebarMenu,
  },
      methods: {
        countDownChanged(dismissCountDown) {
          this.dismissCountDown = dismissCountDown
        },
        addReseachers() {
          this.list_show = false;
          this.add_user = true;
        },
        backLists() {
          this.first_name = '';
          this.last_name = '';
          this.phone_number = '';
          this.email_addr = '';
          this.submit = 'Create CSR';
          this.action = 'insert';
          this.roles = 'ROLE_CSR';
          this.len = 0;
          this.list_show = true;
          this.add_user = false;
        },
        fetchUserData({ page, filter, sort }) {
            return new Promise(resolve => {
                axios.get('/reseacher-users', { headers: { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'Content-Type': 'application/json' }, params: {  _sort: sort, _page: page, role: 'ROLE_CSR' } })
                .then(response => {
                    resolve({
                      data: response.data.data,
                      pagination: {

                        totalPages: response.data.total_pages,
                        currentPage: response.data.page,
                      },
                    });
                    this.len = response.data.data.length;
                  }
                );
            })
        },
        no_result: function() {
          if(this.len === '') {
              return "Loading...";
          }
          if(this.len === 0) {
              return "No CSR found.";
          }
        }
      },

}
</script>



// WEBPACK FOOTER //
// src/components/admin/add_csr.vue